module.exports = __webpack_public_path__ + "static/guide-8f31de48e881f3ff60a1f6ffa4b7b68e.gif";